module.exports = "<p>\n  static-contact works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/src/app/static-contact/static-contact.component.html
// module id = ../../../../../src/app/static-contact/static-contact.component.html
// module chunks = 0